/*
 * MIMI 2026 — 30.09 — Foto scorrevoli nelle schede di collezione su telefono.
 *
 * Il foglio assets/mimi-card-scorri.css trasforma, sui dispositivi senza
 * mouse, le immagini della scheda in una striscia che si scorre col dito.
 * Questo script fa una sola cosa che il CSS non puo' fare: fa caricare la
 * seconda foto appena la scheda entra nello schermo. Il tema la carica
 * «pigra» (loading=lazy) e, stando fuori dal bordo destro della striscia, il
 * browser non la caricherebbe finche' non e' gia' in vista, lasciando un
 * vuoto durante lo scorrimento.
 *
 * Le schede che arrivano dopo (scorrimento continuo, filtri, collezione
 * in evidenza) vengono prese da un MutationObserver.
 * Sul computer (con mouse) lo script non fa nulla.
 * I puntini sotto le foto sono stati tolti il 01.10 su richiesta di Veronica.
 */
(function () {
  if (!window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;

  function carica(media) {
    media.querySelectorAll('img.product-card__image').forEach(function (img) {
      if (img.loading === 'lazy') img.loading = 'eager';
    });
  }

  var osservatoreVista = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (voci) {
        voci.forEach(function (voce) {
          if (!voce.isIntersecting) return;
          carica(voce.target);
          osservatoreVista.unobserve(voce.target);
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function prepara(scheda) {
    var media = scheda.querySelector('.product-card__media');
    if (!media || media.hasAttribute('data-mimi-scorri')) return;
    if (media.querySelectorAll('.product-card__image').length < 2) return;
    media.setAttribute('data-mimi-scorri', '');
    if (osservatoreVista) osservatoreVista.observe(media);
    else carica(media);
  }

  function tutte() {
    document.querySelectorAll('product-card, .product-card').forEach(prepara);
  }

  tutte();

  var inCoda = false;
  new MutationObserver(function () {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () { inCoda = false; tutte(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
